var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticStyle:{"cursor":"pointer"}},[(_vm.width)?_c('img',{style:(("width:" + (this.width) + "px")),attrs:{"src":_vm.$images.qboConnectButton},on:{"click":_vm.qboConnect}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }